import React from 'react';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';

import MenuItem from 'material-ui/MenuItem';

import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';


import { Link } from 'react-router-dom';
const styles = {
    toolbarRoot: {
        backgroundColor: "white"
    },
    menuLinks: {
        marginLeft: "16px"
    }
}


const MenuLayerBig = ({toStoredCommands, toCommands, toLogs, toClient}) => (
    <div>
        <Link style={styles.menuLinks} to={toClient ? toClient.url : "/"} >{toClient ? toClient.display : "Clientes"}</Link>
        {/* <Link style={styles.menuLinks} to={toCommands ? toCommands : "/commands"} >Comandos</Link> */}
        <Link style={styles.menuLinks} to={toStoredCommands ? toStoredCommands : "/storedcommands"} >Comandos almacenados</Link>
        <Link style={styles.menuLinks} to={toCommands ? toCommands : "/commands"} >Comandos</Link> 
        <Link style={styles.menuLinks} to={toLogs ? toLogs : "/logs"} >Logs</Link>  
    </div>
);

//AGREGAR TOCOMMANDLOGS, CAMBIAR TOLOGS A COMMANDS
const MenuLayerSmall = ({toStoredCommands, toCommands, toLogs, toClient}) => (
    <IconMenu
        iconButtonElement={
            <IconButton><MoreVertIcon /></IconButton>
        }
        targetOrigin={{horizontal: 'right', vertical: 'top'}}
        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
    >
        <MenuItem primaryText={toClient ? toClient.display : "Clientes"} onTouchTap={() => { window.location.hash = toClient ? toClient.url : "/" }} />
        <MenuItem primaryText="Comandos almacenados" onTouchTap={() => { window.location.hash = toStoredCommands ? toStoredCommands : "/storedcommands" }} />
        <MenuItem primaryText="Comandos" onTouchTap={() => { window.location.hash = toCommands ? toCommands : "/commands" }} />
        <MenuItem primaryText="Logs" onTouchTap={() => { window.location.hash = toLogs ? toLogs : "/logs" }} />
    </IconMenu>
)

export default ({toStoredCommands, toCommands, toLogs, showOptions, toClient}) => (
    /*
        toClient: {
            url: "",
            display: ""
        }
    */
    <Toolbar style={styles.toolbarRoot}>
        <ToolbarGroup firstChild={true}>
            <ToolbarTitle text="Bridge" style={{marginLeft: "16px", cursor: "pointer" }} onTouchTap={() => { window.location.hash = "/"; }} />
        </ToolbarGroup>
        {
            showOptions === false ?
            <span /> :
            <ToolbarGroup>
                <div className="hidden-xs"> <MenuLayerBig toStoredCommands={toStoredCommands} toCommands={toCommands} toLogs={toLogs} toClient={toClient} /> </div>
                <div className="hidden-sm hidden-md hidden-lg"> <MenuLayerSmall toStoredCommands={toStoredCommands} toCommands={toCommands} toLogs={toLogs} toClient={toClient} /> </div>
            </ToolbarGroup>
        }

    </Toolbar>
);



// WEBPACK FOOTER //
// ./src/components/MainComponents/BridgeAppBar.js